export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9821.67f5790b.jpg";